import { Text } from "components";
import React from "react";
import { MeetingItemRightStyle, MeetingItemStyle } from "../styles";

type Props = {
  title: string;
  startTime: string;
  hasTranscript?: boolean;
  onClick?: () => void;
};
export const TranscriptListItem: React.FC<Props> = ({
  title,
  startTime,
  hasTranscript,
  onClick,
}) => {
  return (
    <div className={MeetingItemStyle} onClick={onClick}>
      <div>
        <Text.BodyXS>{title}</Text.BodyXS>
        {hasTranscript && (
          <Text.Body3XS color="highlight/1">Transcript available</Text.Body3XS>
        )}
      </div>
      <div className={MeetingItemRightStyle}>
        <Text.BodyXS color="tertiary">{startTime}</Text.BodyXS>
        {/* <DotIcon fill="tertiary" style={DotIconStyle} />
        <Text.BodyXS color="highlight/1">See transcript</Text.BodyXS> */}
      </div>
    </div>
  );
};
